import React from 'react';
function Player(props) {

    const { strCutout, strPlayer, strNumber, strTeamBadge, strTeam, strTeamColor, idPlayer, toggleModal } = props;

    return (
        <div key={idPlayer} style={{ backgroundColor: `${strTeamColor}` }} onClick={() => toggleModal(idPlayer)} className='playerCard'>
            <div className='teamInformation'>
                <img className='teamBagde' src={strTeamBadge} alt={`${strPlayer} team bagde`} />
                {/* Equipa do jogador*/}
                <h2 className='playerTeam'>{strTeam}</h2>
            </div>
            <div className='playerInformation'>
                {/* imagem */}
                <img className='playerImage' src={strCutout} alt={`${strPlayer}`} />
                {/* nome do jogador */}
                {/* numero de jogador */}
                <div className='playerNumberDiv' style={{ backgroundColor: `${strTeamColor}` }}><h2 className='playerNumber'>{strNumber}</h2></div>
                {/* numero de jogador */}
                <h1 className='playerName'>{strPlayer}</h1>
            </div>
        </div>
    )
}

export default Player




